import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { UserService } from './user.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  canView: boolean;

  constructor(
    private auth: NbAuthService,
    private router: Router,
    private userService: UserService
    ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const path = route.routeConfig.path;
    let rolesAuth: string[] = [];
    this.userService.getRole().subscribe((roles) => rolesAuth = roles);
    this.auth.isAuthenticated()
    .subscribe((result) => {
      this.canView = result;
    });
    if (!this.canView) {
      this.router.navigate(['/']);
      return this.canView;
   } else {
      return this.canView;
   }
    }

  }
